import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UsersComponent } from '../users.component';

@Component({
  selector: 'app-edit-users',
  templateUrl: './edit-users.component.html',
  styleUrls: ['./edit-users.component.scss']
})
export class EditUsersComponent implements OnInit {

  editUserForm: FormGroup;
  missingFieldMsg = false;
  errorMsg = false;
  @ViewChild('closeBtn') closeBtn: ElementRef;

  @Input() userData: any

  constructor(private appComp: AppComponent, private formBuilder: FormBuilder, private authService: AuthenticationService, private users: UsersComponent) { }

  ngOnInit(): void {
    this.editUserForm = this.formBuilder.group({
      fullname: ["", Validators.required],
      email: ["", Validators.required],
      telephone: [""],
      idRole: [null],
      city: [""],
      active: [null]
    });
  }

  ngOnChanges() {   
    console.log(this.userData);
    if(this.userData){
      this.editUserForm.patchValue({
        fullname: this.userData.fullname,
        email: this.userData.email,
        telephone: this.userData.telephone,
        idRole: this.userData.idRole,
        city: this.userData.city,
        active: this.userData.active
      })
    }
    
  }

  editUser(){
    this.appComp.loading = true;
    this.missingFieldMsg = false;
    if (this.editUserForm.invalid) {
      this.missingFieldMsg = true;
      this.appComp.loading = false;
      return;
    }
    let formObj = this.editUserForm.getRawValue();
    formObj.id = this.userData.id;
    if(typeof formObj.active == "string"){
      formObj.active = formObj.active == 'true' ? true : false;
    }
    console.log(formObj);
    this.authService.editUser(formObj).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.users.getUsers();
      this.appComp.loading = false;
    }, err =>{
      this.errorMsg = true;
      console.log(err);
      this.appComp.loading = false;
    })
  }

}
